// ****************************************************************************************************************************************************
// Utility function to determine whether a given URL belongs to the current domain (local) or is external

export function isLocalUrl(urlToCheck) {
  return urlToCheck !== null && urlToCheck.includes(SITEBASEURL);
}

// ****************************************************************************************************************************************************
// Utility function to add target attribute to external links

export function getLinkTargetAttr(isLocal) {
  return isLocal ? '' : 'target="_blank"';
}

// ****************************************************************************************************************************************************
// Utility to adjust lineup button layout based on container width

export function fixFeatureButton() {
  $('.featureLineupContainer').each((i, element) => {
    const lineup = $(element);
    const containerSize = lineup.width();
    const buttonContainer = lineup.find('.featureLineup-buttons.subContainer');
    const icons = buttonContainer.find('.featureLineup-social');
    const buttons = buttonContainer.find('.featureLineup-buynow');

    if (icons.width() + buttons.width() > containerSize - 20) {
      buttonContainer.addClass('column');
    }

    if (!icons.children().length) {
      icons.remove();
    }
  });
}

// ****************************************************************************************************************************************************
// Function to customize search button

export function customizeSearch() {
  $('.header .searchSubmitButton').attr('tabindex', '-1');

  const input = $('.header .inputFieldTextbox');
  const defaultText = 'Search Website';

  input.on('focus', function () {
    if ($(this).val() === defaultText) {
      $(this).val('');
    }
  });

  input.on('blur', function () {
    if ($(this).val().trim() === '') {
      $(this).val(defaultText);
    }
  });
}

// ****************************************************************************************************************************************************
// Utility function to create custom burger toggle button

export function createCustomToggle() {
  const currentToggle = $(`.mobile-nav-toggle`);
  const closeToggle = $('.mobile-menu-container .close-mobile-menu');

  updateToggle();
  openMenuKeyboard();

  function updateToggle() {
    currentToggle.attr('tabindex', '0');
    for (let i = 0; i < 3; i++) {
      currentToggle.append("<span class='toggle-line'></span>");
    }
  }

  function openMenuKeyboard() {
    currentToggle.on('keydown', function (event) {
      if ((event.key === 'Enter' || event.key === ' ') && !$('body').hasClass('mobile-menu-open')) {
        $(this).trigger('click');
        closeMenuKeyboard();
      }
    });
  }

  function closeMenuKeyboard() {
    closeToggle.attr('tabindex', '0');
    closeToggle.focus();

    closeToggle.on('keydown', function (event) {
      if ((event.key === 'Enter' || event.key === ' ') && $('body').hasClass('mobile-menu-open')) {
        $(this).trigger('click');
      }
      currentToggle.focus();
    });
  }
}

// ****************************************************************************************************************************************************
// Utility function to calculate content margin top

export function updateContentMargin() {
  function applyMargin() {
    const headerHeight = $('header').outerHeight();

    const mq = globalThis.matchMedia('(max-width: 1100px)');
    const additionalValue = mq.matches ? 20 : 30;

    const content = $('.content');
    const isHomepage = $('body').hasClass('homepage');

    content.css(
      'margin-top',
      isHomepage ? `${headerHeight}px` : `${headerHeight + additionalValue}px`,
    );
  }

  applyMargin();

  $(globalThis).on('resize', applyMargin);

  $(globalThis).on('scroll', function () {
    if ($(this).scrollTop() === 0) {
      setTimeout(applyMargin, 300);
    }
  });

  new ResizeObserver(applyMargin).observe(document.querySelector('.header'));
}
